import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Activity, Calendar, Clock } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { namespace } from '@common-config/constants';

interface BotStatsProps {
  stats?: {
    activeSessions?: number;
    todaySessions?: number;
    avgDuration?: string;
    latestDeployment?: {
      createdAt?: string;
    };
  };
}

export const BotStats: React.FC<BotStatsProps> = ({ stats }) => {
  const { t } = useTranslation(namespace);
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <Card style={{
        backgroundColor: 'var(--bot-detail-card-bg)',
        border: '1px solid var(--bot-detail-card-border)',
        boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
      }}>
        <CardContent className="p-6">
          <div className="flex items-center">
            <div style={{
              marginRight: '16px',
              padding: '8px',
              backgroundColor: 'var(--bot-detail-stat-icon-bg-emerald)',
              borderRadius: '9999px',
            }}>
              <Activity 
                className="h-5 w-5" 
                style={{ color: 'var(--bot-detail-stat-icon-emerald)' }}
              />
            </div>
            <div>
              <p style={{
                fontSize: '0.875rem',
                fontWeight: '500',
                color: 'var(--bot-detail-stat-label)',
              }}>
                {t('chatbot.botDetail.stats.activeSessions')}
              </p>
              <h3 style={{
                fontSize: '1.5rem',
                fontWeight: '700',
                color: 'var(--bot-detail-stat-value)',
              }}>
                {stats?.activeSessions !== undefined ? stats.activeSessions : '--'}
              </h3>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card style={{
        backgroundColor: 'var(--bot-detail-card-bg)',
        border: '1px solid var(--bot-detail-card-border)',
        boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
      }}>
        <CardContent className="p-6">
          <div className="flex items-center">
            <div style={{
              marginRight: '16px',
              padding: '8px',
              backgroundColor: 'var(--bot-detail-stat-icon-bg-blue)',
              borderRadius: '9999px',
            }}>
              <Calendar 
                className="h-5 w-5" 
                style={{ color: 'var(--bot-detail-stat-icon-blue)' }}
              />
            </div>
            <div>
              <p style={{
                fontSize: '0.875rem',
                fontWeight: '500',
                color: 'var(--bot-detail-stat-label)',
              }}>
                {t('chatbot.botDetail.stats.todaysSessions')}
              </p>
              <h3 style={{
                fontSize: '1.5rem',
                fontWeight: '700',
                color: 'var(--bot-detail-stat-value)',
              }}>
                {stats?.todaySessions !== undefined ? stats.todaySessions : '--'}
              </h3>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card style={{
        backgroundColor: 'var(--bot-detail-card-bg)',
        border: '1px solid var(--bot-detail-card-border)',
        boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
      }}>
        <CardContent className="p-6">
          <div className="flex items-center">
            <div style={{
              marginRight: '16px',
              padding: '8px',
              backgroundColor: 'var(--bot-detail-stat-icon-bg-purple)',
              borderRadius: '9999px',
            }}>
              <Clock 
                className="h-5 w-5" 
                style={{ color: 'var(--bot-detail-stat-icon-purple)' }}
              />
            </div>
            <div>
              <p style={{
                fontSize: '0.875rem',
                fontWeight: '500',
                color: 'var(--bot-detail-stat-label)',
              }}>
                {t('chatbot.botDetail.stats.averageDuration')}
              </p>
              <h3 style={{
                fontSize: '1.5rem',
                fontWeight: '700',
                color: 'var(--bot-detail-stat-value)',
              }}>
                {stats?.avgDuration || '--'}
              </h3>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}; 
